<template>
        <div class="Bgcontain">
            <!-- <bgame></bgame> -->
            <div class="my-container">
                <div class="row">
                    <ul class="menus">
                        <li v-for="(item,index) in menu" :key="item.name" :class="{active:selectIndex===index}" @click="listClick(index)">
                            <div class="menusList">   
                            <span>{{item.name}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="my-container addpad">
                <div class="hb row text-center" v-show="selectIndex == 0">
                    <div v-if="!HB.length"></br>没有数据</div>
                    <div class="col-xs-3" v-for="(item,index) in CQ9" :key="item.img" 
                    :data-aos='index==0?"fade-down-right":index==1?"fade-down":index==2?"fade-down":index==3?"fade-down-left":index==4?"fade-right":index==5?"zoom-in":index==6?"zoom-in":index==7?"fade-left":index==8?"fade-up-right":index==9?"fade-up":index==10?"fade-up":index==11?"fade-up-left":""'
                    data-aos-easing="linear" data-aos-duration="300">
                        <img :src="item.img" />
                        <div class="over-hide">
                            <a target="_blank" :href="item.href"><img src="../assets/images/startgame.png" /></a>
                        </div>
                    </div>
                </div>
                <div class="hb row text-center" v-show="selectIndex == 1">
                    <div v-if="!HB.length"></br>没有数据</div>
                    <div class="col-xs-3" v-for="(item,index) in PG" :key="item.img" 
                    :data-aos='index==0?"fade-down-right":index==1?"fade-down":index==2?"fade-down":index==3?"fade-down-left":index==4?"fade-right":index==5?"zoom-in":index==6?"zoom-in":index==7?"fade-left":index==8?"fade-up-right":index==9?"fade-up":index==10?"fade-up":index==11?"fade-up-left":""'
                    data-aos-easing="linear" data-aos-duration="300">
                        <img :src="item.img" />
                        <div class="over-hide">
                            <a target="_blank" :href="item.href"><img src="../assets/images/startgame.png" /></a>
                        </div>
                    </div>
                </div>
        
        
                <div class="bs row text-center" v-show="selectIndex == 2">
                    <div v-if="!BS.length"></br>没有数据</div>
                    <div class="col-xs-3" v-for="item in HB" :key="item.img">
                        <img :src="item.img" />
                        <div class="over-hide">
                            <a target="_blank" :href="item.href"><img src="../assets/images/startgame.png" /></a>
                        </div>
                    </div>
                </div>
                <div class="bs row text-center" v-show="selectIndex == 3">
                    <div v-if="!BS.length"></br>没有数据</div>
                    <div class="col-xs-3" v-for="item in BS" :key="item.img">
                        <img :src="item.img" />
                        <div class="over-hide">
                            <a target="_blank" :href="item.href"><img src="../assets/images/startgame.png" /></a>
                        </div>
                    </div>
                </div>
        
        
                <!-- <div class="webgame row text-center" v-show="selectIndex == 2">
                    <div v-if="!webgame.length"></br>没有数据</div>
                    <div class="col-xs-3" v-for="item in webgame" :key="item.img">
                        <a target="_blank" :href="item.href"><img :src="item.img" /><span>{{item.name}}</span></a>
                    </div>
                </div> -->

                <!-- <div class="row text-center" v-show="selectIndex == 2">
                    <div v-if="!lifes.length"></br>没有数据</div>
                    <div class="col-xs-3" v-for="item in lifes" :key="item.img">
                        <a target="_blank" :href="item.href">
                            <img :src="item.img" />
                            <div>
                                <p>{{item.name}}</p>
                                <p v-html="item.memo"></p>
                            </div>
                        </a>
                    </div>
                </div> -->
        
                <!-- <div class="tools row text-center" v-show="selectIndex == 3">
                    <div v-if="!tools.length"></br>没有数据</div>
                    <div class="col-xs-3" v-for="item in tools" :key="item.img">
                        <a target="_blank" :href="item.href">
                            <img :src="item.img" />
                            <div>
                                <p>{{item.name}}</p>
                                <p v-html="item.memo"></p>
                            </div>
                        </a>
                    </div>
                </div> -->

                <!-- <gameTools v-show="selectIndex == 3" :tools="tools"></gameTools> -->
        
        
                <div class="adult row text-center" v-show="selectIndex == 4">
                    <div v-if="!adult.length"></br>没有数据</div>
                    <div class="col-xs-3" v-for="(item,index) in adult" :key="item.img">
                        <a href="javascript:;" @click="adultClick(index)"><img :src="item.img"/></a>
                    </div>
                </div>
        
                
        
            </div>      
        </div>
</template>

<script>
// import aos from 'aos'
// import bgame from './b.game'
import lifes from '../../static/data/lifes.json'
import tools from '../../static/data/tools.json'
import webgame from '../../static/data/webgame.json'
import axios from '../axios'
import gameTools from './c.game.tools.vue'
export default {
    data() {
        return {
            lifes:lifes.kinds,
            tools:tools.kinds,
            webgame:webgame.kinds,
            adult:[],
            CQ9: [
                {
                    img: require('../assets/images/52.jpg'),
                    href: 'https://h5c.cqgame.games/52/?token=guest123&language=zh-cn'
                },
                {
                    img: require('../assets/images/72.jpg'),
                    href: 'https://h5c.cqgame.games/72/?token=guest123&language=zh-cn'
                },
                {
                    img: require('../assets/images/24.jpg'),
                    href: 'https://h5c.cqgame.games/24/?token=guest123&language=zh-cn'
                },
                {
                    img: require('../assets/images/58.jpg'),
                    href: 'https://h5c.cqgame.games/58/?token=guest123&language=zh-cn'
                },
                {
                    img: require('../assets/images/49.jpg'),
                    href: 'https://h5c.cqgame.games/49/?token=guest123&language=zh-cn'
                },
                {
                    img: require('../assets/images/50.jpg'),
                    href: 'https://h5c.cqgame.games/50/?token=guest123&language=zh-cn'
                },
                {
                    img: require('../assets/images/19.jpg'),
                    href: 'https://h5c.cqgame.games/19/?token=guest123&language=zh-cn'
                },
                {
                    img: require('../assets/images/33.jpg'),
                    href: 'https://h5c.cqgame.games/33/?token=guest123&language=zh-cn'
                },
                {
                    img: require('../assets/images/76.jpg'),
                    href: 'https://h5c.cqgame.games/76/?token=guest123&language=zh-cn'
                },
                {
                    img: require('../assets/images/74.jpg'),
                    href: 'https://h5c.cqgame.games/74/?token=guest123&language=zh-cn'
                },
                {
                    img: require('../assets/images/79.jpg'),
                    href: 'https://h5c.cqgame.games/79/?token=guest123&language=zh-cn'
                },
                {
                    img: require('../assets/images/56.jpg'),
                    href: 'https://h5c.cqgame.games/56/?token=guest123&language=zh-cn'
                }
            ],
            PG: [
                {
                    img: require('../assets/images/gem-saviour.jpg'),
                    href: 'https://m.pgsoft.me/gem-saviour/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                },
                {
                    img: require('../assets/images/hood-wolf.jpg'),
                    href: 'https://m.pgsoft.me/hood-wolf/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                },
                {
                    img: require('../assets/images/steam-punk.jpg'),
                    href: 'https://m.pgsoft.me/steam-punk/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                },
                {
                    img: require('../assets/images/summon-conquer.jpg'),
                    href: 'https://m.pgsoft.me/summon-conquer/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                },
                {
                    img: require('../assets/images/wizdom-wonders.jpg'),
                    href: 'https://m.pgsoft.me/wizdom-wonders/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                },
                {
                    img: require('../assets/images/plushie-frenzy.jpg'),
                    href: 'https://m.pgsoft.me/plushie-frenzy/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                },
                {
                    img: require('../assets/images/medusa.jpg'),
                    href: 'https://m.pgsoft.me/medusa/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                },
                {
                    img: require('../assets/images/peas-fairy.jpg'),
                    href: 'https://m.pgsoft.me/peas-fairy/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                },
                {
                    img: require('../assets/images/fortune-tree.jpg'),
                    href: 'https://m.pgsoft.me/peas-fairy/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                },
                {
                    img: require('../assets/images/diaochan.jpg'),
                    href: 'https://m.pgsoft.me/diaochan/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                },
                {
                    img: require('../assets/images/fortune-gods.jpg'),
                    href: 'https://m.pg-redirect.us/fortune-gods/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                },
                {
                    img: require('../assets/images/win-win-won.jpg'),
                    href: 'https://m.pgsoft.me/win-win-won/index.html?language=zh&bet_type=2&real_url=https%3A%2F%2Fwww.pgsoft.com%2Fen%2Fpartners%2F&from=https%3A%2F%2Fintegration.pgsoft.me%2Fdownload%2Fclose.html'
                }
            ],
            HB: [
                {
                    img: require('../assets/images/SGFireRooster.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGFireRooster&mode=fun&locale=zh-CN'
                },
                {
                    img: require('../assets/images/SGZeus.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGZeus&mode=fun&locale=zh-CN'
                },
                {
                    img: require('../assets/images/SGBirdOfThunder.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGBirdOfThunder&mode=fun&locale=zh-CN'
                },
                {
                    img: require('../assets/images/SGQueenOfQueens1024.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGQueenOfQueens1024&mode=fun&locale=zh-CN'
                },
                {
                    img: require('../assets/images/SGMummyMoney.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGMummyMoney&mode=fun&locale=zh-CN'
                },
                {
                    img: require('../assets/images/SGHauntedHouse.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGHauntedHouse&mode=fun&locale=zh-CN'
                },
                {
                    img: require('../assets/images/SGTowerOfPizza.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGTowerOfPizza&mode=fun&locale=zh-CN'
                },
                {
                    img: require('../assets/images/SGPandaPanda.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGPandaPanda&mode=fun&locale=zh-CN'
                },
                {
                    img: require('../assets/images/SGArcticWonders.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGArcticWonders&mode=fun&locale=zh-CN'
                },
                {
                    img: require('../assets/images/SGTheKoiGate.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGTheKoiGate&mode=fun&locale=zh-CN'
                },
                {
                    img: require('../assets/images/SGShaolinFortunes243.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGShaolinFortunes243&mode=fun&locale=zh-CN'
                },
                {
                    img: require('../assets/images/SGSuperTwister.jpg'),
                    href: 'https://app-test.insvr.com/games/?ts=fun&keyname=SGSuperTwister&mode=fun&locale=zh-CN'
                }
            ],
            BS: [
                {
                    img: require('../assets/images/691.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=691&lang=zh'
                },
                {
                    img: require('../assets/images/553.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=553&lang=zh'
                },
                {
                    img: require('../assets/images/755.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=755&lang=zh'
                },
                {
                    img: require('../assets/images/759.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=759&lang=zh'
                },
                {
                    img: require('../assets/images/700.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=700&lang=zh'
                },
                {
                    img: require('../assets/images/654.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=654&lang=zh'
                },
                {
                    img: require('../assets/images/341.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=341&lang=zh'
                },
                {
                    img: require('../assets/images/002.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=002&lang=zh'
                },
                {
                    img: require('../assets/images/177.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=177&lang=zh'
                },
                {
                    img: require('../assets/images/262.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=262&lang=zh'
                },
                {
                    img: require('../assets/images/490.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=490&lang=zh'
                },
                {
                    img: require('../assets/images/534.jpg'),
                    href: 'https://ptpt-c2ss.betsoftgaming.com/guestmode.do?bankId=1101&gameId=534&lang=zh'
                }
            ],
            menu: [
                {
                    name: 'CQ9试玩',
                    img:require('../assets/images/game1.png')
                },
                {
                    name: 'PG试玩',
                    img:require('../assets/images/game2.png')
                },
                {
                    name: 'HB试玩',
                    img:require('../assets/images/game1.png')
                },
                {
                    name: 'BS试玩',
                    img:require('../assets/images/game2.png')
                },
                {
                    name: '成人乐园',
                    img:require('../assets/images/logo_7.png')
                }
            ],
            selectIndex: 0
        }
    },
    components:{
        gameTools,
        // bgame
    },
    created(){
        let that = this;
        axios.getAdult(function(data){
            that.adult = data.data.kinds;
        })

        setInterval(()=>{
           // this.selectIndex = (++this.selectIndex) % this.menu.length
        },28000)
    },
    mounted() {
        // aos.init()
    },
    methods: {
        listClick(index) {
            this.selectIndex = index
        },
        adultClick(index){
            window.open(this.adult[index].href)
        }
    }
}
</script>

<style scoped>
.my-container{
    width: 1345px;
    background: #1d1d1d;
}
.my-container.addpad{
    padding-bottom: 150px;
    margin: 0 auto;
}
ul {
    padding: 0;
    height: 100px;
    line-height: 60px;
}

li {
    list-style-type: none;
    display: inline-block;
    width: 20%;
    text-align: center;
    font-size: 17px;
    color: rgb( 106, 104, 104);
    cursor: pointer;
    position: relative;
}
.menus{
    padding: 20px 10px; 
    background: #1d1d1d;
    height: 100px;
}
.menus .menusList{
    margin:0 10px;
    background:url(../assets/images/normal.jpg) no-repeat top center;
    color: #fff

}

.active .menusList{
    background:url(../assets/images/cur.jpg) no-repeat top center;
    color: #fff;
    background-size: cover;
    color: #1d1d1d
}

.col-xs-3 {
    margin-top: 20px;
    position: relative;
}

.row:first-child {
    margin-top: 20px;
}

.col-xs-3>img{
    width: 300px;
    height: 175px;
    /* box-shadow: 1px 2px 2px 2px #666;     */
    /* border-radius: 10px; */
}
.over-hide {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 20px;
    width: 300px;
    height: 175px;
    background: rgba(86, 86, 86, 0.5);
    /* border-radius: 10px; */
}
.over-hide img{
    margin-top: 55px;
}
.col-xs-3:hover .over-hide{
    opacity: 1;
    cursor: pointer;
    border: 1px solid #ffff00;
}


.col-xs-3>a{
        position: relative;
        display: inline-block;
}

.col-xs-3>a>span{
    display: inline-block;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 30px;
    background: rgba(0,0,0,0.4);
    width: 100%;
    line-height: 30px;
    border-radius: 0 0 10px 10px;
    color: #fff;
}

.col-xs-3>a{    
    transition: all .5s linear;
}

a:focus, a:hover{
    text-decoration: none;
}

/*精选网游*/
.webgame>.col-xs-3>a>img {
    width: 256px;
    height: 156px;
    box-shadow: 1px 1px 0px 2px #666;    
    border-radius: 10px;
} 
.webgame .col-xs-3>a:hover{
    transform: scale(1.1,1.1);
}


/*常用工具*/
.tools>.col-xs-3>a{
    width: 100%;
    height: 90px;
    margin-top:10px; 
}  
.tools>.col-xs-3>a>img{
    height: 72px;
    width: 72px;
    margin-right:20px; 
}
.tools>.col-xs-3>a>div{
    display: inline-block;
    text-align: left;
    vertical-align:bottom;
}
.tools .col-xs-3>a:hover{
    transform: scale(1.1,1.1);
}
.menus li:nth-child(5) img{
    margin: -2px 0 0 10px;
}
/*成人乐园*/
.adult .col-xs-3>a:hover{
    transform: scale(1.1,1.1);
} 

.adult>.col-xs-3 {
    height: 110px;
    margin-top:60px;
}

.adult>.col-xs-3>a>img{
    width: 100%;    
    height: inherit!important;
}
.Bgcontain{
    position: relative;
    overflow: hidden;
    background: url(../assets/images/thirdFloorBg.jpg) no-repeat center top;

}
@media screen and (max-width:768px){
    .my-container{
        width: 100%;
    }
    .Bgcontain{
        overflow: hidden;
        background: url(../assets/images/thirdFloorBg.jpg) no-repeat center top;
        background-size: cover;

    }
    .my-container.addpad{
        padding-bottom:25px; 
    }
    .menus{
    padding: 10px 0px; 
    background: #1d1d1d;
    height: 50px;
    }
    .menus .menusList{
        margin:0 10px 0 0;
        background:url(../assets/images/normal.jpg) no-repeat top center;
        color: #fff;
        background-size: 100% 100%;
    }

    .active .menusList{
        background:url(../assets/images/cur.jpg) no-repeat top center;
        color: #fff;
        background-size: cover;
        color: #1d1d1d;
        background-size: 100% 100%;
    }
    ul {
        padding: 0;
        height: 100px;
        line-height: 40px;
    }
    .col-xs-3>img {
        box-shadow: 1px 2px 2px 2px #000000;
        border-radius: 10px;
    }
}

</style>




// WEBPACK FOOTER //
// src/components/c.game.vue